import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

interface DisplayValueProps {
  label?: string;
  displayUnit?: string;
  fractionDigits?: number;
}

@Component({
  selector: 'formly-display-value',
  template: `
    <div class="display-value">
      <span class="display-value-label gea-font-heading-16">{{ props.label }}</span>
      <span class="display-value-content gea-font-body-16">{{ formattedValue }}</span>
    </div>
  `,
  styles: `
    .display-value {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .display-value-label {
      font-weight: 600;
    }

    .display-value-label,
    .display-value-content {
      display: block;
      line-height: 156%;
    }

    .display-value-content {
      color: var(--geaui-primary-black);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDisplayValueComponent extends FieldType<FieldTypeConfig<DisplayValueProps>> {
  get formattedValue(): string {
    const value = this.formControl.value;
    const fractionDigits = this.props.fractionDigits;
    const formattedValue =
      typeof value === 'number'
        ? value.toLocaleString('de-DE', {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
          })
        : String(value ?? '');
    const unit = this.props.displayUnit ?? '';
    const separator = unit === '%' || !unit ? '' : ' ';

    return `${formattedValue}${separator}${unit}`;
  }
}
